export function mapsSearchUrl(query) {
  if (!query) return null;
  const q = encodeURIComponent(String(query).trim());
  return `https://www.google.com/maps/search/?api=1&query=${q}`;
}
